module.exports = __webpack_public_path__ + "static/img/pageBg1.776be84.png";


//////////////////
// WEBPACK FOOTER
// ./static/pageBg1.png
// module id = j5uh
// module chunks = 1